import script from "./SmsRequestForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SmsRequestForm.vue?vue&type=script&setup=true&lang=js"

import "./SmsRequestForm.vue?vue&type=style&index=0&id=5436ed53&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5436ed53"]])

export default __exports__